import {Shift} from "../model/lib/interfaces/Shift";

export class ShiftHelper {
  public static readonly DEFAULT_SHIFT_NAME = 'default';

  public static isSingleDefaultShift(shifts: Shift[]): boolean {
    return !!shifts && shifts.length === 1 && ShiftHelper.isDefaultShift(shifts[0]);
  }

  public static isDefaultShift(shift: Shift): boolean {
    return !!shift && !!shift.name && shift.name.trim().toLowerCase() === ShiftHelper.DEFAULT_SHIFT_NAME;
  }
}



// WEBPACK FOOTER //
// ./src/utils/shift-helper.ts